<template>
  <div id="gtexBox"></div>
</template>

<script>
import Highcharts from "highcharts/highstock";
import HighchartsMore from "highcharts/highcharts-more";
import HighchartsDrilldown from "highcharts/modules/drilldown";
import axios from "axios";

HighchartsMore(Highcharts);
HighchartsDrilldown(Highcharts);

export default {
  props: ["ensgId"],
  watch: {
    ensgId() {
      axios
        .get(
          "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/searchGTEx.php",
          {
            params: {
              ensgId: this.ensgId,
            },
          }
        )
        .then((response) => {
          console.log(response.data);
          this.plotBubble(response.data["xaxis"], response.data["yaxis"]);
        });
    },
  },
  mounted() {
    axios
      .get(
        "http://research.gzsys.org.cn/perturbdb/API/perturbedgene/searchGTEx.php",
        {
          params: {
            ensgId: this.ensgId,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        this.plotBubble(response.data["xaxis"], response.data["yaxis"]);
      });
  },
  data() {
    return {
      chart: {},
    };
  },
  methods: {
    plotBubble(xdata, ydata) {
      this.chart = new Highcharts.chart("gtexBox", {
        //去掉水印
        credits: {
          enabled: false,
        },
        chart: {
          type: "boxplot",
        },
        title: {
          text: "",
        },
        legend: {
          enabled: false,
        },
        xAxis: {
          categories: xdata,
          title: {
            text: "",
          },
          lineColor: "black",
          lineWidth: 2,
          tickWidth: 2,
          tickLength: 5,
          tickColor: "black",
          crosshair: true,
        },
        yAxis: {
          title: {
            text: "TPM",
          },
          tickWidth: 2,
          tickColor: "black",
          lineWidth: 2,
          lineColor: "black",
          tickLength: 5,
          gridLineColor: "white",
        },
        series: [
          {
            name: "Expression",
            data: ydata,
            color: "black",
            fillColor: "#aa4643",
            tooltip: {
              headerFormat: "<em>Tissue: {point.key}</em><br>",
            },
          },
        ],
      });
    },
  },
};
</script>

<style></style>
